function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import { injectIntl } from "react-intl";
import classNames from "classnames";
import MenuChapter from "../containers/AppMenuChapter";
import { FakeChapters } from "../constants/chapters";
import ProgressDisplay from "./ProgressDisplay";
import Icon from "./Icon";
var AppMenuChapter = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(AppMenuChapter, _React_Component);
    var _super = _createSuper(AppMenuChapter);
    function AppMenuChapter(props) {
        _classCallCheck(this, AppMenuChapter);
        var _this;
        _this = _super.call(this, props);
        _this.renderSlide = function(chart) {
            var _this_props = _this.props, isComplete = _this_props.isComplete, isAvailable = _this_props.isAvailable, isFavorite = _this_props.isFavorite, intl = _this_props.intl, currentSlide = _this_props.currentSlide, chapterIndex = _this_props.chapterIndex, toggleFavorite = _this_props.toggleFavorite, goTo = _this_props.goTo, getFirstChapterSlide = _this_props.getFirstChapterSlide, isCurrentSlideInChapter = _this_props.isCurrentSlideInChapter, getSlideIndex = _this_props.getSlideIndex, getNonRegularChapterProgress = _this_props.getNonRegularChapterProgress, getChapterIndexes = _this_props.getChapterIndexes, getSlideStatus = _this_props.getSlideStatus, isChapterCompleted = _this_props.isChapterCompleted;
            if (!chart) {
                return null;
            }
            if (chart.target_type === "Filter" && !chart.is_regular_chapter && chart.c.length === 0) {
                return null;
            }
            var isVisited;
            if (chart.target_type === "Filter" && !chart.is_regular_chapter) {
                isVisited = isChapterCompleted(chart.id);
            } else {
                isVisited = isComplete(chart.id);
            }
            var isFav = isFavorite(chart.id);
            var available = isAvailable(chart);
            var examStatus = chart.target_type === "Exam" ? getSlideStatus(chart.id) : "";
            var isCurrentSlide;
            var nonRegularChapterProgress = {
                trackableSlidesCount: 0,
                trackableCompletedSlidesCount: 0
            };
            if (chart.target_type === "Filter" && !chart.is_regular_chapter) {
                isCurrentSlide = isCurrentSlideInChapter(chart.id) || false;
                if (chart.c.length > 0) {
                    nonRegularChapterProgress = getNonRegularChapterProgress(chart.id);
                }
            } else {
                isCurrentSlide = currentSlide === chart.id;
            }
            var classes = classNames("chart-menu__link", {
                "chart-menu__link--active": isCurrentSlide,
                "chart-menu__link--do-not-track": chart.do_not_track,
                "chart-menu__link--disabled": !available && chart.target_type === "Filter" && chart.is_regular_chapter
            });
            var favClasses = classNames("chart-menu__fav-btn", {
                "chart-menu__fav-btn--active": isFav
            });
            var visClasses = classNames("chart-menu__visited", {
                "chart-menu__visited--active": isVisited
            });
            var slideClasses = classNames("chart-menu__item", {
                "chart-status__visited": isVisited,
                "chart-status__not-visited": !isVisited
            }, "chart-type__".concat(chart.target_type.toLowerCase()), examStatus && "exam-status-".concat(examStatus.replace(" ", "-")));
            if (chart.target_type === "Filter" && !chart.is_regular_chapter) {
                _this.slideCount += 1;
            }
            var ind = chapterIndex.slice();
            ind.push(_this.slideCount);
            return chart.target_type === "Filter" && chart.is_regular_chapter ? /*#__PURE__*/ React.createElement(MenuChapter, {
                nodeId: chart.id,
                chapterIndex: ind,
                key: chart.id
            }) : /*#__PURE__*/ React.createElement("li", {
                className: slideClasses,
                ref: function(el) {
                    _this.ownRefs["chart_" + chart.id] = el;
                },
                key: chart.id,
                id: "chart_".concat(chart.id)
            }, chart.target_type === "Filter" && !chart.is_regular_chapter && chart.c.length > 0 ? /*#__PURE__*/ React.createElement(ProgressDisplay, {
                compact: true,
                maxVal: nonRegularChapterProgress.trackableSlidesCount,
                val: nonRegularChapterProgress.trackableCompletedSlidesCount
            }) : null, !chart.do_not_track && /*#__PURE__*/ React.createElement("div", {
                className: visClasses
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "checkmark-bold",
                size: "s"
            })), /*#__PURE__*/ React.createElement("a", {
                className: classes,
                "data-index": chart.target_type === "Filter" ? getChapterIndexes(chart.id) : getSlideIndex(chart.id) + 1,
                href: "?chart=".concat(chart.id),
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    goTo(chart.target_type === "Filter" && !chart.is_regular_chapter ? getFirstChapterSlide(chart.id) : chart.id);
                }
            }, isCurrentSlide ? /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, intl.formatMessage({
                id: "menu.current_slide",
                defaultMessage: "Current slide"
            })) : null, /*#__PURE__*/ React.createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: chart.name
                }
            }), isVisited && /*#__PURE__*/ React.createElement("span", {
                className: "sr-only"
            }, intl.formatMessage({
                id: "ui.viewed",
                defaultMessage: "Viewed"
            }))), chart.target_type !== "Filter" ? /*#__PURE__*/ React.createElement("button", {
                role: "checkbox",
                disabled: !available,
                className: favClasses,
                "aria-label": intl.formatMessage({
                    id: "menu.toggle_favourite",
                    defaultMessage: "Toggle favourite"
                }),
                "aria-checked": isFav,
                onClick: function(evnt) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                    toggleFavorite(chart.target_type === "Filter" && !chart.is_regular_chapter ? getFirstChapterSlide(chart.id) : chart.id);
                }
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: isFav ? "star-fill" : "star-outline",
                size: "s"
            })) : null);
        };
        _this.getAlternativeTitle = function(chapter) {
            var _this_props = _this.props, intl = _this_props.intl, chapterIndex = _this_props.chapterIndex;
            if (!chapter.alt) {
                return "".concat(intl.formatMessage({
                    id: "ui.chapter",
                    defaultMessage: "Chapter"
                }), " ").concat(chapterIndex.join("."));
            } else if (chapter.alt === FakeChapters.FAVORITES) {
                return intl.formatMessage({
                    id: "ui.favourites",
                    defaultMessage: "Favourites"
                });
            } else {
                return chapter.alt;
            }
        };
        _this.renderChapter = function(chapter) {
            var _this_props = _this.props, chapterAvailable = _this_props.chapterAvailable, chapterIndex = _this_props.chapterIndex, favCount = _this_props.favCount, getNodes = _this_props.getNodes, intl = _this_props.intl, trackableSlidesCount = _this_props.trackableSlidesCount, trackableCompletedSlidesCount = _this_props.trackableCompletedSlidesCount;
            var open = _this.state.open;
            var subNodes = getNodes(chapter.c || []);
            var subNodesListId = "chapter_subnodes_".concat(chapter.id);
            var classes = classNames("title", {
                open: open,
                "chapter-do-not-track": chapter.do_not_track,
                "chapter-not-available": !chapterAvailable
            });
            var alternativeTitle = _this.getAlternativeTitle(chapter);
            return /*#__PURE__*/ React.createElement("li", {
                className: "app-menu__chapter level-".concat(chapterIndex.length)
            }, /*#__PURE__*/ React.createElement("button", {
                className: classes,
                "aria-expanded": _this.state.open,
                "aria-controls": subNodesListId,
                onClick: _this._toggleChapter
            }, chapter.id && !chapter.do_not_track && trackableSlidesCount && /*#__PURE__*/ React.createElement(ProgressDisplay, {
                compact: true,
                maxVal: trackableSlidesCount,
                val: trackableCompletedSlidesCount
            }), /*#__PURE__*/ React.createElement("div", {
                className: "title-wrapper"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "title-super"
            }, alternativeTitle), chapter.name === FakeChapters.FAVORITES ? /*#__PURE__*/ React.createElement("span", null, favCount, " ", intl.formatMessage({
                id: "ui.search_result",
                defaultMessage: "found"
            })) : /*#__PURE__*/ React.createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: chapter.name
                }
            })), /*#__PURE__*/ React.createElement(Icon, {
                name: "chevron-right",
                size: "m"
            })), /*#__PURE__*/ React.createElement("ul", {
                className: "chart-menu".concat(open ? " open" : ""),
                id: subNodesListId,
                hidden: !_this.state.open
            }, subNodes.map(function(n) {
                return _this.renderSlide(n);
            })));
        };
        _this._toggleChapter = function(evnt) {
            if (evnt) {
                evnt.preventDefault();
                evnt.stopPropagation();
            }
            _this.setOpen(!_this.state.open);
        };
        /**
   * Taken from https://stackoverflow.com/a/73379243
   */ _this.scrollParentToChild = function(parent, child) {
            // Where is the parent on page
            var parentRect = parent.getBoundingClientRect();
            // What can you see?
            var parentViewableArea = {
                height: parent.clientHeight,
                width: parent.clientWidth
            };
            // Where is the child?
            var childRect = child.getBoundingClientRect();
            // Is the child viewable?
            var isViewable = childRect.top >= parentRect.top && childRect.bottom <= parentRect.top + parentViewableArea.height;
            // if you can't see the child try to scroll parent
            if (!isViewable) {
                // Should we scroll using top or bottom? Find the smaller ABS adjustment
                var scrollTop = childRect.top - parentRect.top;
                var scrollBot = childRect.bottom - parentRect.bottom;
                if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
                    // we're near the top of the list
                    parent.scrollTop += scrollTop;
                } else {
                    // we're near the bottom of the list
                    parent.scrollTop += scrollBot + 16;
                }
            }
        };
        _this.state = {
            open: props.startsOpen
        };
        _this.ownRefs = {};
        _this.slideCount = 0;
        return _this;
    }
    var _proto = AppMenuChapter.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setOpen(this.props.startsOpen);
        if (this.props.startsOpen && this.props.currentSlide) {
            var parent = document.getElementById("app-menu__results");
            var child = document.getElementById("chart_" + this.props.currentSlide);
            if (parent && child) {
                this.scrollParentToChild(parent, child);
            }
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, _prevState) {
        var _this_props = this.props, currentSlide = _this_props.currentSlide, chapter = _this_props.chapter, startsOpen = _this_props.startsOpen;
        if (prevProps.startsOpen !== startsOpen) {
            var parent = document.getElementById("app-menu__results");
            var child = document.getElementById("chart_" + this.props.currentSlide);
            if (parent && child) {
                this.setOpen(true);
                this.scrollParentToChild(parent, child);
            }
        }
        if (prevProps.currentSlide !== this.props.currentSlide && chapter && currentSlide && chapter.c.indexOf(currentSlide) > -1) {
            var parent1 = document.getElementById("app-menu__results");
            var child1 = document.getElementById("chart_" + this.props.currentSlide);
            if (parent1 && child1) {
                this.setOpen(true);
                this.scrollParentToChild(parent1, child1);
            }
        }
    };
    _proto.render = function render() {
        var chapter = this.props.chapter;
        var isChapter = !!chapter && chapter.target_type === "Filter";
        this.slideCount = 0;
        return isChapter && (chapter.is_regular_chapter || chapter.name === FakeChapters.FAVORITES) ? this.renderChapter(chapter) : this.renderSlide(chapter);
    };
    _proto.setOpen = function setOpen(open) {
        this.setState({
            open: open
        });
    };
    return AppMenuChapter;
}(React.Component);
export default injectIntl(AppMenuChapter);
